import { createAction } from "redux-act";
export const REQUEST_STATE_LIST = "REQUEST_STATE_LIST";
export const REQUEST_STATE_FAILED = "REQUEST_STATE_FAILED";
export const REQUEST_STATE_SUCCESS = "REQUEST_STATE_SUCCESS";

export const requestState = createAction(REQUEST_STATE_LIST);
export const requestStateFailed = createAction(REQUEST_STATE_FAILED);
export const requestStateSuccess = createAction(REQUEST_STATE_SUCCESS);
